<template>
  <li :style="`--order:${itemOrder ?? 99}`">
    <NavigationLink :route="route" />
  </li>
</template>

<script>
import NavigationLink from '@/components/Navigation/NavigationLink.vue';

export default {
  name: 'NavigationItem',
  components: {
    NavigationLink,
  },
  props: {
    route: {
      type: Object,
      required: true,
    },
    itemOrder: {
      type: Number,
      default: 99,
    },
  },
};
</script>
